import type { PropsWithChildren } from 'react';
import { Box, Stack } from '@mantine/core';

import Skeleton from '@/components/content/placeholder/Skeleton';
import { MercuryCol, MercuryGrid } from '@/components/grid/Grid';

const IssuePlaceholder = ({ isLoading, children }: PropsWithChildren<{ isLoading: boolean }>) => (
  <>
    {isLoading ? (
      <MercuryGrid columns={20}>
        <MercuryCol span={{ base: 20, md: 14 }} transparent>
          <Box>
            <Skeleton height={500} />

            <Box mt={25}>
              <Skeleton height={100} />
            </Box>
          </Box>
        </MercuryCol>

        <MercuryCol span={{ base: 20, md: 6 }} transparent>
          <Stack gap={15}>
            <Skeleton n={10} key="placeholder-right" height={40} />
          </Stack>
        </MercuryCol>
      </MercuryGrid>
    ) : (
      children
    )}
  </>
);

export default IssuePlaceholder;
